module.exports = __webpack_public_path__ + "static/media/correct.aea2162e.wav";